var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavoriteIconActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 459.699,
    height: 459.699,
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_10"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_13"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_14"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_15"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_16"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_17"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_19",
    d: "m13.84949,186.34949l142.15051,-35.34949l68,-124l74,120l140,31l-85,114l8,146l-123,-60l-137,60c0.84949,0.34949 13.84949,-157.65051 13.84949,-157.65051c0,0 12,-12 -101,-94z",
    opacity: "NaN",
    stroke: "#000",
    fill: "#ffff00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_1",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    fill: "#ffff00",
    d: "m458.028,175.409c-3.984,-12.26 -14.383,-21.027 -27.139,-22.88l-118.084,-17.158l-52.808,-107.002c-5.706,-11.56 -17.257,-18.741 -30.148,-18.741s-24.443,7.181 -30.148,18.741l-52.808,107.002l-118.083,17.158c-12.757,1.853 -23.156,10.62 -27.14,22.88c-3.983,12.26 -0.724,25.465 8.507,34.464l85.446,83.289l-20.171,117.606c-2.179,12.706 2.945,25.305 13.375,32.883c5.782,4.199 12.615,6.42 19.762,6.42c5.427,0 10.836,-1.336 15.642,-3.862l105.617,-55.526l105.618,55.526c4.805,2.527 10.214,3.862 15.642,3.862c7.148,0 13.981,-2.22 19.764,-6.42c10.429,-7.578 15.553,-20.177 13.374,-32.882l-20.171,-117.607l85.447,-83.29c9.23,-8.998 12.49,-22.204 8.506,-34.463zm-30.29,12.118l-91.32,89.014c-3.677,3.584 -5.355,8.749 -4.487,13.81l21.558,125.692c0.156,0.913 -0.211,1.818 -0.96,2.361c-0.525,0.382 -1.063,0.462 -1.422,0.462c-0.394,0 -0.771,-0.093 -1.121,-0.277l-112.877,-59.343c-2.272,-1.195 -4.766,-1.792 -7.26,-1.792s-4.988,0.597 -7.262,1.793l-112.877,59.343c-0.35,0.185 -0.727,0.278 -1.122,0.278c-0.358,0 -0.897,-0.08 -1.421,-0.461c-0.749,-0.544 -1.116,-1.449 -0.96,-2.362l21.558,-125.691c0.868,-5.061 -0.81,-10.226 -4.487,-13.81l-91.32,-89.014c-0.663,-0.646 -0.897,-1.595 -0.611,-2.475c0.287,-0.881 1.033,-1.511 1.95,-1.644l126.2,-18.338c5.082,-0.739 9.475,-3.93 11.748,-8.535l56.439,-114.358c0.41,-0.83 1.239,-1.346 2.165,-1.346c0.926,0 1.755,0.516 2.165,1.346l56.437,114.355c2.273,4.605 6.666,7.797 11.748,8.535l126.201,18.338c0.916,0.134 1.663,0.763 1.949,1.644c0.286,0.88 0.052,1.829 -0.611,2.475z",
    stroke: "null"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteIconActive);
export default __webpack_public_path__ + "static/media/favorite-icon-active.ee6aa7727e1775333573c0ae03de9d41.svg";
export { ForwardRef as ReactComponent };